const BASE_URL = 'https://jes-secret-api.herokuapp.com'

export const API_URL = (slug) => `${BASE_URL}/${slug}`
